import {createSlice} from '@reduxjs/toolkit'

export const saveProspectList = createSlice({
  name: 'saveProspects',
  initialState: {
    data: [],
    value: [],
    listDescription: ''
  },
  reducers: {
    constituentIdList: (state, action) => {
      state.value = action.payload
    },
    allSavedProspectsList: (state, action) => {
      state.data = action.payload
    },
    setListDescription: (state, action) => {
      state.listDescription = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {constituentIdList, allSavedProspectsList, setListDescription} = saveProspectList.actions

export default saveProspectList.reducer
